<template>
  <div>
    <div class="akskResource-title">
      <div>AKSK</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:iamConfig:akskResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:iamConfig:akskResource:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="akskResource-top">
      <aksk-resource-search ref="reserveAkskSearch"></aksk-resource-search>
    </div>
    <table-aksk-resource></table-aksk-resource>
  </div>
</template>

<script>
import AkskResourceSearch from "../aksk/AkskResourceSearch";
import TableAkskResource from "../aksk/TableAkskResource";

export default {
  name: "AkskResource",
  components: {
    AkskResourceSearch,
    TableAkskResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.reserveAkskSearch.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 14
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.companyId = this.$refs.reserveAkskSearch.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAwsIamAKSK({
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "aws-iam-aksk.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.akskResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.akskResource-title > div:nth-child(1) {
  float: left;
}
.akskResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.akskResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/aksk/AkskResource.vue